const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/com/eCheckin/ECheckinForm.tsx';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import PersAngaben from 'App/config/com/eCheckin/sections/PersAngaben';
import PatientInfo from 'App/config/com/eCheckin/sections/PatientInfo';
import Arzt from 'App/config/com/eCheckin/sections/Arzt';
import Versicherung from 'App/config/com/eCheckin/sections/Versicherung';
import KontaktPerson from 'App/config/com/eCheckin/sections/KontaktPerson';
import textMap from 'App/config/com/eCheckin/translations';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import Finalize from 'App/config/com/eCheckin/sections/Finalize';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';
import { Kostenuebernahme } from './sections/KostenUebernahme';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path="persAngaben" title={textMap.persAngaben} />
            <PatientInfo path="patInfo" title={textMap.patInfo} />
            <Arzt path="einwArzt" title={textMap.einwArzt} />
            <KontaktPerson path="kontakt" title={textMap.kontakt} />
            <Versicherung path="versicherung" title={textMap.versicherungLabel} />
            <Kostenuebernahme path="kostenuebernahme" title={textMap.kostenuebernahme} />
            <Finalize path="_finalizeSection" title={textMap.finalizeTitle} />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
